(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('authorizeTransitionHook', authorizeTransitionHook);

    var noop = angular.noop;

    authorizeTransitionHook.$inject = ['$q', 'signInManager', 'loginStateName', 'logoutStateName', 'user'];
    function authorizeTransitionHook($q, signInManager, loginStateName, logoutStateName, user) {
        return {
            onBefore: [{ to: notLogin }, hook]
        };

        function notLogin(state) {
            return state.name !== loginStateName;
        }

        function hook(transition) {
            var target = transition.router.stateService.target,
                targetState = transition.targetState(),
                targetStateInternal = targetState.state(),
                targetStateData = targetStateInternal && targetStateInternal.data || {},
                allowAnonymous = targetStateData.allowAnonymous;

            return !allowAnonymous ? signInManager.isSignedIn().then(checkRoles).catch(error) : null;

            function checkRoles() {
                if (targetStateData.requireAssociationAdmin)
                    return user.isAssociationAdmin ? true : $q.reject('Not Authorized');
                else if (targetStateData.requireAdmin)
                    return user.isAdmin ? true : $q.reject('Not Authorized');
                else
                    return true;
            }

            function error() {
                var redirectTo = targetState.name(),
                    redirectParams = targetState.params();

                // Bug fix:  we don't want the login's redirect url to ever be login or logout.
                if (redirectTo === loginStateName || redirectTo === logoutStateName)
                    redirectTo = redirectParams = null;

                return target(loginStateName, { redirectTo: redirectTo, redirectParams: redirectParams });
            }
        }
    }
})();